import React, { ReactNode, useEffect, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import MyAppText from './MyAppText';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { Hoverable } from 'react-native-web-hover';

export interface TabInfo {
    key: string;
    label: string;
    icon?: IconDefinition;
    omit?: boolean;
}

interface TabsParameters {
    tabs: TabInfo[];
    children: ({ selectedTab }: { selectedTab: string; }) => React.ReactNode | undefined;
    endContent?: ReactNode;
    selectedTab?: string;
}

export function Tabs({ children, tabs, endContent, selectedTab }: TabsParameters) {
    const { styles, theme } = useStyles(stylesheet);
    const [internalSelectedTab, setInternalSelectedTab] = useState(tabs[0].key);

    useEffect(() => {
        if (selectedTab) {
            setInternalSelectedTab(selectedTab);
        }
    }, [selectedTab]);

    return (
        <View style={{ rowGap: 15, flex: 1 }}>
            <View style={styles.container}>
                {tabs.filter(tab => !tab.omit).map((tab) => (
                    <View key={tab.key} style={{
                        borderBottomWidth: internalSelectedTab == tab.key ? 2 : 0,
                        borderColor: internalSelectedTab == tab.key ? theme.colors.tabs.selected : undefined,
                        padding: 6
                    }}>
                        <TouchableOpacity onPress={() => setInternalSelectedTab(tab.key)}>
                            <Hoverable style={{
                                flexDirection: 'row',
                                columnGap: 5,
                                alignItems: 'center',
                                paddingHorizontal: tab.icon ? 5 : 0
                            }}>
                                {({ hovered }) => (<>

                                    {tab.icon ?
                                        <FontAwesomeIcon icon={tab.icon} fontSize={14} color={internalSelectedTab == tab.key || hovered ? theme.colors.tabs.selected : theme.colors.tabs.border} />
                                        : null
                                    }

                                    <MyAppText style={[styles.tabText, {
                                        color: internalSelectedTab == tab.key || hovered ? theme.colors.tabs.selected : theme.colors.tabs.border
                                    }]}>{tab.label}</MyAppText>
                                </>)}
                            </Hoverable>

                        </TouchableOpacity>
                    </View>
                ))}
                {endContent
                    ? <View style={{ flex: 1 }}>
                        {endContent}
                    </View>
                    : null}
            </View >
            {children({ selectedTab: internalSelectedTab })}
        </View>
    );
}

const stylesheet = createStyleSheet(theme => ({
    container: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: theme.colors.tabs.border,
        columnGap: 8,
        overflowY: 'auto',
    },
    tabText: {
        fontWeight: 'bold',
        fontSize: 14,
    }
}));
